export const GET_ARTICLES = 'app/Articles/GET_ARTICLES';
export const GET_ARTICLES_AGGREGATIONS = 'app/Articles/GET_ARTICLES_AGGREGATIONS';
